import Input from "./Input";
import DatePicker from "./DatePicker";
import PhoneInput from "./PhoneInput";
import RadioGroup from "./RadioGroup";
import CheckboxGroup from "./CheckboxGroup";
import Editor from "./Editor";
import PriceInput from "./PriceInput";
import Select from "./Select";
import Toggle from "./Toggle";
import Upload from "./Upload";
import TagsInput from "./TagsInput";

export default {
  Input,
  DatePicker,
  PhoneInput,
  RadioGroup,
  CheckboxGroup,
  Editor,
  PriceInput,
  Select,
  Toggle,
  Upload,
  TagsInput
};
